import { ref } from "vue";
const bus = ref(new Map());

export const useEventsBus = () => {
  const emit = <T>(event: string, ...args: T[]) => {
    bus.value.set(event, args);
  };

  return {
    emit,
    bus,
  };
};
